export default (collection = {}, items = {}) =>
  Object.entries(collection).reduce((acc, [key, value]) => {
    const newValue = value - (items[key] || 0);
    return newValue === 0 ? acc : { ...acc, [key]: newValue };
  }, {});
